import React, { Component } from "react"
import { fileUrl } from '../../../../../../util/file_url'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
export default class ImagePreview extends Component {

    render() {
        return (
            <div id="attachment-form-preview" style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                overflow: 'hidden'
            }}>
                <TransformWrapper>
                    <TransformComponent>
                        <img 
                            src={fileUrl(this.props.filename)} 
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain'
                            }} 
                            alt=""
                        /> 
                    </TransformComponent>
                </TransformWrapper>
            </div>
        );
    }
};